import { Component, DestroyRef, effect, EventEmitter, input, Input, InputSignal, OnInit, Output } from "@angular/core";
import { BehaviorSubject, ReplaySubject } from "rxjs";
import { ISelectOption } from "src/app/models/selectOptions/selectOption.interface";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: "app-select",
    templateUrl: "./select.component.html",
    styleUrls: ["./select.component.scss"],
})
export class SelectComponent implements OnInit {
    @Input() public placeHolder = "";
    public optionSelected: InputSignal<ISelectOption | null | undefined> = input();
    @Input() public options: ISelectOption[];
    @Input() public canBeEmpty: boolean;
    @Input() public withoutShowingSelection = false;
    @Input() public noBorder = false;
    @Input() public useLabelProviderPipe = false;
    @Input() public useBeutifyStringProviderPipe = false;

    /**
     * @deprecated Use "optionSelected" signal instead
     */
    @Input() public clearSelectionObservable?: BehaviorSubject<undefined>;

    @Input() public optionSelectObservable?: ReplaySubject<ISelectOption>;
    @Input() public newOptionObservable?: ReplaySubject<ISelectOption[]>;
    @Input() public disabled?: boolean = false;
    @Input() public selectOptionIndexObservable?: ReplaySubject<number>;
    @Output() public optionOnSelection = new EventEmitter<ISelectOption>();
    @Output() public clearSelection = new EventEmitter<void>();

    public selectedIndex = -1;
    public optionsVisible = false;

    constructor(private _destroyRef: DestroyRef) {
        effect(() => {
            if (this.optionSelected() && this.options) {
                this.selectedIndex = this.options.findIndex((option) => option === this.optionSelected());
            }
        });
    }

    ngOnInit(): void {
        const optionSelected = this.optionSelected();
        if (optionSelected) {
            this.selectedIndex = this.options.findIndex(
                (option) => option.displayName === optionSelected.displayName && option.id === optionSelected.id,
            );
        }
        if (this.clearSelectionObservable) {
            this.clearSelectionObservable.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
                this.selectedIndex = -1;
            });
        }
        if (this.optionSelectObservable) {
            this.optionSelectObservable.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((optionSelected: ISelectOption | null) => {
                if (optionSelected) {
                    this.selectedIndex = this.options.findIndex(
                        (option) => option.displayName === optionSelected.displayName && option.id === optionSelected.id,
                    );

                    this.optionOnSelection.emit(this.options[this.selectedIndex]);
                }
            });
        }
        if (this.newOptionObservable) {
            this.newOptionObservable.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((options: ISelectOption[]) => {
                this.options = options;
            });
        }
        if (this.selectOptionIndexObservable) {
            this.selectOptionIndexObservable.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((index: number) => {
                this.selectedIndex = index;
            });
        }
    }

    public onSelect(index: number): void {
        if (!this.options[index].disabled) {
            this.optionsVisible = false;
            if (this.withoutShowingSelection) {
                this.optionOnSelection.emit(this.options[index]);
                return;
            }
            if (this.selectedIndex !== index) {
                this.selectedIndex = index;
                this.optionOnSelection.emit(this.options[this.selectedIndex]);
                return;
            }
            if (this.selectedIndex === index && this.canBeEmpty) {
                this.selectedIndex = -1;
                this.clearSelection.emit();
            }
        }
    }

    public inputOnClick(): void {
        if (this.disabled) return;

        this.optionsVisible = !this.optionsVisible;
    }
}
